<template>
  <div>
    <router-link
        :to="{ name: 'advertising_banners_edit', params: { hashid: row.id } }"
        class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        title="جزئیات"
    >
      <i class="fa fa-eye"></i>
    </router-link>


    <a v-if="row.status !== 0" href="#" v-on:click.prevent="archiveBanner" class="btn btn-sm btn-clean btn-icon btn-icon-sm" title="آرشیو">
      <i class="fa fa-archive"></i>
    </a>
    <a v-else href="#" v-on:click.prevent="restoreBanner" class="btn btn-sm btn-clean btn-icon btn-icon-sm" title="بازیابی">
      <i class="fa fa-redo"></i>
    </a>

    <a href="#" v-on:click.prevent="deleteBanner" class="btn btn-sm btn-clean btn-icon btn-icon-sm" title="حذف">
      <i class="fa fa-trash"></i>
    </a>
  </div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import { bannerService } from '@/common/api.service'
import toastr from 'toastr'

export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    }
  },
  computed: {
    selector() {
      return $('tr[data-row="'+this.index+'"')
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    }
  },
  methods : {
    deleteBanner(e) {
      if (!confirm('آیا از حذف این بنر مطمئن هستید؟')) {
        return
      }

      bannerService.delete(this.row.id).then(
          response => {
            this.toastr.success(response.data.message)
            this.datatable.reload()
          },
          error => {
            this.toastr.error(error.response.data.message || 'خطا در حذف')
          }
      )
    },
    archiveBanner(e) {
      bannerService.archive(this.row.id).then(
          response => {
            this.toastr.success(response.data.message)
            this.datatable.reload()
          },
          error => {
            this.toastr.error(error.response.data.message)
          }
      )
    },
    restoreBanner(e) {
      bannerService.restore(this.row.id).then(
          response => {
            this.toastr.success(response.data.message)
            this.datatable.reload()
          },
          error => {
            this.toastr.error(error.response.data.message)
          }
      )
    },
  },
})
</script>